import { Link } from "@remix-run/react"
import Autoplay from "embla-carousel-autoplay"
import { CardProduct } from "~/types"
import { getBackgroundStyle } from "~/utils/utils"
import { Carousel, CarouselContent, CarouselItem } from "../ui/carousel"
import NewArrivalSmallProductCard from "./NewArrivalSmallProductCard"

// =============================================================
type Props = {
  products: any[]
  logo: string
  link: string
  bgColor: string
}
// =============================================================

export default function NewArrivalSmallCard({
  products,
  logo,
  bgColor,
  link,
}: Props) {
  return (
    <div
      className="relative flex flex-col justify-between h-full rounded-3xl md:rounded-[50px] p-3 md:p-5"
      style={getBackgroundStyle(bgColor)}
    >
      <div>
        <img src={logo} alt="brandlogo" className="h-6 md:h-12" />
      </div>
      {/* Product Carousel */}
      <div className="relative z-10 mt-4 md:mt-7">
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          plugins={[Autoplay({ delay: 8000 })]}
          className="[&>div]:px-1 w-full"
        >
          <CarouselContent className="py-2">
            {products.map((item: any, index) => (
              <CarouselItem key={index} className="basis-1/2 md:basis-1/3">
                <NewArrivalSmallProductCard
                  item={
                    {
                      id: item?.id,
                      name: item?.productName,
                      defaultVariantId: item?.productVariantId,
                      priceWithTax: item?.regularPrice,
                      shortDescription: item?.description,
                      slug: item?.sku,
                      image: item?.assets[0] ?? "",
                      inStock: item?.stockOnHand > 0,
                      assets: item?.assets ?? [],
                      discountPercent: item?.discountPercent ?? 0,
                      computedPrice: item?.computedPrice ?? 0,
                      giftProducts: item?.hasGiftProducts,
                      productType: item?.variantType,
                      discountEndDate: item?.discountEndDate,
                      wholesalePrice: item?.wholesalePrice,
                      wholesaleMoq: item?.wholesaleMoq,
                      stockOnHand: item?.stockOnHand,
                      facetValueIds: item?.facetValueIds ?? [],
                    } as CardProduct
                  }
                />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
      <div className="mt-6 relative z-20 w-fit">
        <Link
          to={link}
          reloadDocument
          className="bg-white/10 text-white px-4 py-3 rounded-2xl inline-block w-full text-center"
        >
          Дэлгэрэнгүй
        </Link>
      </div>
    </div>
  )
}
